import { formatAgeRangeDraft, parseAgeRange, validateAgeRangeDraft } from './ageRange';

export const getSuggestedTopPicksAgeScope = (readingAge, options = {}) => {
  if (typeof readingAge !== 'string') {
    return null;
  }

  const normalizedReadingAge = readingAge.trim();
  if (!normalizedReadingAge) {
    return null;
  }

  const draft = parseAgeRange(normalizedReadingAge, options);
  const error = validateAgeRangeDraft(draft, options);
  if (error) {
    return null;
  }

  return {
    draft,
    normalizedValue: formatAgeRangeDraft(draft, options)
  };
};
